import { push } from 'react-router-redux';
import Cookies from 'js-cookie';

import forceLogoutHandler from '../users/a.users.forceLogoutHandler';

import {

} from '../actions.export'

////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////
// Get knowledge by organization
////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////

export const requestGetKnowledgeByOrganization = packet => {
  return {
    type: 'REQUEST_GET_KNOWLEDGE_BY_ORGANIZATION',
    data: {
      lastSubmit: packet
    }
  }
}

export const receiveGetKnowledgeSuccessByOrganization = data => ({
  type: 'RECEIVE_GET_KNOWLEDGE_BY_ORGANIZATION_SUCCESS',
  data
})

export const receiveGetKnowledgeFailByOrganization = data => ({
  type: 'RECEIVE_GET_KNOWLEDGE_BY_ORGANIZATION_FAIL',
  data
})

export const tryToGetKnowledgeByOrganization = packet => (dispatch, getState) => {

  dispatch(requestGetKnowledgeByOrganization(packet));

  let headers = {
    "Content-Type": "application/json"
  }
  


  let fs = localStorage.getItem(process.env.REACT_APP_COOKIE_FEATURE_SWITCH);
  if(fs){
    headers["X-NFS"] = fs;
  }


  headers["X-CSRF-TOKEN"] = getState().userReducer.csrf_token;

  let url = '/api/knowledge/org/' + packet.org_id;
  if(packet.startAfter){
    url += '?startAfter=' + packet.startAfter;
  }

  return fetch(url, {
      method: 'get',
      headers: headers
    })
    .then((response) => {
      let json = response.json();
      if (response.status >= 200 && response.status < 300) return json;
      return json.then(Promise.reject.bind(Promise));
    })
    .then(function(json){
      dispatch(receiveGetKnowledgeSuccessByOrganization(json));
    })
    .catch(e => {
      dispatch(forceLogoutHandler(e));
      dispatch(receiveGetKnowledgeFailByOrganization({errors:e, lastSubmit: packet}));
    })
}
